export const uiComponents = {
	uiMap: 'ui--map',
	systemBeacons: 'system--beacons',
	systemBeaconList: 'system--beacon-list',
	systemInformation: 'system--info',
	systemLock: 'system--lock',
	systemSecurity: 'system--security',
	uiKeypad: 'ui--keypad',
	uiLanguage: 'ui--language',
	uiFontSize: 'ui--fontSize',
	uiColorMode: 'ui--colorMode',
	uiContent: 'ui--content',
	uiVideo: 'ui--video',
	uiVr: 'ui--vr',
	uiGallery: 'ui--gallery',
	uiAudio: 'ui--audio',
	uiLoader: 'ui--loader',
	uiMessages: 'ui--messages',
	ui3d: 'ui--3d',
	uiARWarning: 'ui--ar-warning',
	uiARCoreKitWarning: 'ui--ar-corekit-warning',
	wrapperArticleCurrent: 'wrapper--article--current',
	navigationTop: 'ui--top',
	navigationQuiz: 'ui--quiz',
	navigationBottom: 'ui--bottom',
	navigationTour: 'ui--tour',
	navigationLeft: 'ui--left',
	navigationRight: 'ui--right',
	uiSearchLocations: 'ui--search--locations',
	uiSearchGlossary: 'ui--search--glossary',
	uiSearchExhibitions: 'ui--search--exhibitions',
	uiSearchCalendar: 'ui--search--calendar',
	uiSearchAreabeacons: 'ui--search--areabeacons',
	uiSearchArticles: 'ui--search--articles',
	uiSearchTour: 'ui--search--tour',
	uiSearchTours: 'ui--search--tours',
};

export const uiStates = {
	minimized: 'minimized',
	maximised: 'maximised',
	hidden: 'hidden',
};

export const mutuallyExclusiveComponentsList = [
	uiComponents.ui3d,
	uiComponents.systemBeacons,
	uiComponents.systemBeaconList,
	uiComponents.systemInformation,
	uiComponents.systemSecurity,
	uiComponents.uiKeypad,
	uiComponents.uiContent,
	uiComponents.uiVideo,
	uiComponents.uiVr,
	uiComponents.uiGallery,
	uiComponents.uiLanguage,
	uiComponents.uiFontSize,
	// uiComponents.uiMap,
	uiComponents.navigationLeft,
	uiComponents.navigationRight,
	// uiComponents.uiSearch,
];

export const mutuallyExclusiveComponents = new Map(
	mutuallyExclusiveComponentsList.map(entry => [entry, true])
);

export function viewIsOpen(state, name) {
	return state.viewState[name].uiState !== uiStates.hidden;
}
